import { handleBridgeAgentConfig } from '../../agents/acp/from-bridge/handle-bridge-agent-config.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleAgentConfigMessage: BridgeMessageHandler<'agent_config'> = (msg, deps) => {
  handleBridgeAgentConfig(msg, deps);
};
